import React from 'react';
export function CtaSection() {
  return <section id="contact" className="py-20 bg-[#8d6e4b] text-white" data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-19">
          Rejoignez-nous pour bâtir l'avenir, bloc par bloc.
        </h2>
        <p className="text-xl text-[#e8e0cc] mb-10 max-w-3xl mx-auto" data-id="element-20">
          Ensemble, transformons l'industrie de la construction pour un futur
          plus durable. Que vous soyez investisseur, élu local, partenaire
          potentiel ou simplement intéressé par notre projet, nous serions ravis
          d'échanger avec vous.
        </p>
        <a href="mailto:hello@materrea.io" className="text-xl font-medium text-white hover:text-[#e8e0cc] transition-colors" data-id="element-21">
          hello@materrea.io
        </a>
      </div>
    </section>;
}